module.exports = __webpack_public_path__ + "static/validate-field-300ebc8e4a500a9c58e8e7b07d4f331f.gif";